var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"insights_container"}},[_c('div',{attrs:{"id":"cards_container"}},_vm._l((_vm.cardInfo),function(card){return _c('div',{key:card.insight_id},[_c('InsightsCard',{staticClass:"Ins_card",attrs:{"card":card,"callback":_vm.callback}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }